'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product13__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.mV;
      break;
    }
    case 1: {
      return $thiz.n0;
      break;
    }
    case 2: {
      return $thiz.n1;
      break;
    }
    case 3: {
      return $thiz.n2;
      break;
    }
    case 4: {
      return $thiz.n3;
      break;
    }
    case 5: {
      return $thiz.n4;
      break;
    }
    case 6: {
      return $thiz.n5;
      break;
    }
    case 7: {
      return $thiz.n6;
      break;
    }
    case 8: {
      return $thiz.n7;
      break;
    }
    case 9: {
      return $thiz.mW;
      break;
    }
    case 10: {
      return $thiz.mX;
      break;
    }
    case 11: {
      return $thiz.mY;
      break;
    }
    case 12: {
      return $thiz.mZ;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 12)"));
    }
  }
}
export { $f_s_Product13__productElement__I__O as $f_s_Product13__productElement__I__O };
